import App from './App.svelte';
import wasm from '../Cargo.toml';

const init = async () => {
	const bindings = await wasm();
	// "http://127.0.0.1:7860"
	const client = await new bindings.create_client("https://ai.doublesymmetry.com");

	const app = new App({
		target: document.body,
		props: { wasm: bindings, client }
	});
};

init();
